/* Archive grid — interactive sort for the archive index.
   The section renders every card with a stable, server-computed file number
   (data-fileno) and a sortable publish key (data-date), defaulting to
   newest-first via CSS `order`. This script just re-writes `order` when the
   visitor picks a different sort. No fetch, no reload. Progressive: with JS
   off, the server default (newest-first) still stands. */
(function () {
  'use strict';

  function keyDate(el) {
    // data-date is YYYYMMDDHHMMSS (undated = 99999999999999 → sorts newest).
    var v = parseInt(el.getAttribute('data-date'), 10);
    return isNaN(v) ? 0 : v;
  }

  function keyTitle(el) {
    return (el.getAttribute('data-title') || '').trim();
  }

  var COMPARATORS = {
    newest: function (a, b) { return keyDate(b) - keyDate(a) || keyTitle(a).localeCompare(keyTitle(b)); },
    oldest: function (a, b) { return keyDate(a) - keyDate(b) || keyTitle(a).localeCompare(keyTitle(b)); },
    az: function (a, b) { return keyTitle(a).localeCompare(keyTitle(b)) || keyDate(b) - keyDate(a); },
    za: function (a, b) { return keyTitle(b).localeCompare(keyTitle(a)) || keyDate(b) - keyDate(a); }
  };

  function applySort(grid, mode) {
    var cmp = COMPARATORS[mode] || COMPARATORS.newest;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.archive-card'));
    cards.sort(cmp);
    cards.forEach(function (card, i) { card.style.order = i; });
  }

  function init(select) {
    var root = select.closest('.archive');
    if (!root) return;
    var grid = root.querySelector('.archive-grid');
    if (!grid) return;

    // Honour the server-set default on load (keeps DOM order === select value).
    applySort(grid, select.value);

    select.addEventListener('change', function () {
      applySort(grid, select.value);
    });
  }

  function boot() {
    var selects = document.querySelectorAll('[data-archive-sort]');
    Array.prototype.forEach.call(selects, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
